var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZkBioCloudVisitorLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.632,
    height: 26.18,
    viewBox: "0 0 206.632 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZKBio-cloud-visitor-white-Logo",
    transform: "translate(-65.7 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(65.7 169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(56.094 2.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M441.3,208.614V190.2h5.406a6.046,6.046,0,0,1,3.883,1.165,3.726,3.726,0,0,1,1.449,3.076,4.353,4.353,0,0,1-.866,2.688,4.6,4.6,0,0,1-2.375,1.658v.045a4.676,4.676,0,0,1,3,1.419,4.322,4.322,0,0,1,1.12,3.062,4.861,4.861,0,0,1-1.7,3.853,6.433,6.433,0,0,1-4.376,1.464H441.3Zm2.375-16.338v5.765h2.165a4.064,4.064,0,0,0,2.7-.836,2.876,2.876,0,0,0,.986-2.33c0-1.732-1.165-2.6-3.48-2.6Zm0,7.841v6.422h2.852a4.288,4.288,0,0,0,2.882-.866,2.975,2.975,0,0,0,1.016-2.389c0-2.106-1.434-3.166-4.286-3.166Z",
    transform: "translate(-441.3 -189.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M534.8,186.064a1.429,1.429,0,0,1,1.464-1.464,1.441,1.441,0,0,1,1.06.418,1.419,1.419,0,0,1,.433,1.045,1.363,1.363,0,0,1-.433,1.03,1.49,1.49,0,0,1-1.06.4,1.455,1.455,0,0,1-1.045-.4A1.351,1.351,0,0,1,534.8,186.064Zm.269,17.787V190.693h2.33V203.85Z",
    transform: "translate(-520.836 -184.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M569.3,230.519a7.1,7.1,0,0,1,1.822-5.137,6.526,6.526,0,0,1,4.928-1.882,6.02,6.02,0,0,1,4.645,1.807,8.129,8.129,0,0,1-.1,10.051,6.309,6.309,0,0,1-4.809,1.912,6.142,6.142,0,0,1-4.7-1.852A6.792,6.792,0,0,1,569.3,230.519Zm2.375-.075a5.3,5.3,0,0,0,1.15,3.584,3.918,3.918,0,0,0,3.091,1.314,3.727,3.727,0,0,0,3.047-1.284,7,7,0,0,0,0-7.363,3.727,3.727,0,0,0-3.047-1.284,3.806,3.806,0,0,0-3.091,1.344A5.509,5.509,0,0,0,571.675,230.445Z",
    transform: "translate(-550.184 -217.691)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_673_",
    transform: "translate(24.418 3.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M255.037,209.171h3.719l-7.736-9.364.075-.075-.06-.045,7.183-8.587h-3.405l-5.795,7.333-.881.881V191.1h-2.808v15.681h-2.255v-.015h-9.9l10.051-14.531V191.1H229.992v2.4h9.274L229.2,207.961v1.21h18.937v-6.482l1.016-1.016Z",
    transform: "translate(-229.2 -191.1)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M76.3,195.18l-.523-.224c-2.614-1.09-8.826-4.212-10.036-9.752h0a7.839,7.839,0,0,1-.045-.792v-6.123c0-3.3.015-6.631.015-6.676v-.836L76.3,169l10.454,1.822V184.98a4.906,4.906,0,0,1-1.075,3.181c-1.553,2.27-4.57,4.555-8.991,6.81Zm-8.572-10.32c.478,2.091,1.941,4.032,4.361,5.78a21.709,21.709,0,0,0,4.152,2.33c8.378-4.346,8.572-7.452,8.572-7.751l-.03-.119.03-.06V172.51l-8.468-1.479-8.6,1.449C67.716,177.378,67.7,184.054,67.731,184.86Zm17.085.388ZM67.7,184.771v.03C67.716,184.8,67.7,184.786,67.7,184.771Z",
    transform: "translate(-65.7 -169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_",
    transform: "translate(7.93 4.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M121.324,206.578a2.539,2.539,0,1,0-2.524-2.539A2.534,2.534,0,0,0,121.324,206.578Zm-.09,10.723,2.569-9.872h-4.884Z",
    transform: "translate(-118.8 -201.5)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(94.833 7.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M711.094,234.207a8.206,8.206,0,0,1-3.838.806,6.265,6.265,0,0,1-4.764-1.882A6.851,6.851,0,0,1,700.7,228.2a7.149,7.149,0,0,1,2.016-5.287,6.887,6.887,0,0,1,5.093-2.016,8.368,8.368,0,0,1,3.286.567v2.24a5.829,5.829,0,0,0-3.047-.821,4.826,4.826,0,0,0-3.6,1.419,5.234,5.234,0,0,0-1.374,3.793,5.006,5.006,0,0,0,1.284,3.6,4.454,4.454,0,0,0,3.375,1.344,6,6,0,0,0,3.345-.911v2.076Z",
    transform: "translate(-700.7 -220.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M788.225,231.627H786V217.2h2.225Z",
    transform: "translate(-773.261 -217.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M820.943,257.3a4.808,4.808,0,0,1-3.6-1.359A4.951,4.951,0,0,1,816,252.312a4.8,4.8,0,0,1,5.182-5.212,4.66,4.66,0,0,1,3.554,1.344,5.178,5.178,0,0,1,1.269,3.719,5.112,5.112,0,0,1-1.374,3.734A4.964,4.964,0,0,1,820.943,257.3Zm.1-8.453a2.5,2.5,0,0,0-2.046.911,3.74,3.74,0,0,0-.747,2.494,3.613,3.613,0,0,0,.762,2.419,2.559,2.559,0,0,0,2.031.881,2.407,2.407,0,0,0,2-.866,4.7,4.7,0,0,0,0-4.943A2.387,2.387,0,0,0,821.048,248.847Z",
    transform: "translate(-798.781 -242.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M905.577,258.337h-2.21V256.8h-.03a3.191,3.191,0,0,1-2.987,1.777c-2.3,0-3.45-1.389-3.45-4.152V248.6h2.21v5.585c0,1.747.672,2.628,2.031,2.628a2.045,2.045,0,0,0,1.613-.717,2.794,2.794,0,0,0,.627-1.9v-5.6h2.2Z",
    transform: "translate(-867.599 -243.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M979.5,231.542h-2.21v-1.658h-.045a3.813,3.813,0,0,1-6.168.567A5.444,5.444,0,0,1,970,226.882a5.926,5.926,0,0,1,1.195-3.868,3.9,3.9,0,0,1,3.181-1.464,3.043,3.043,0,0,1,2.867,1.583h.045V217.1h2.21Zm-2.18-4.45v-1.269a2.5,2.5,0,0,0-.672-1.762,2.265,2.265,0,0,0-1.717-.717,2.313,2.313,0,0,0-1.941.926,4.057,4.057,0,0,0-.7,2.554,3.624,3.624,0,0,0,.687,2.345,2.226,2.226,0,0,0,1.837.866,2.284,2.284,0,0,0,1.837-.836A3.381,3.381,0,0,0,977.318,227.091Z",
    transform: "translate(-929.782 -217.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M1068.153,219.7l4.017,9.409,4.017-9.409h2.853l-6.87,14.86-6.87-14.86Z",
    transform: "translate(-1010.849 -219.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M1162.514,220.524a1.31,1.31,0,0,1-.926-.358,1.186,1.186,0,0,1-.388-.9,1.242,1.242,0,0,1,.388-.911,1.31,1.31,0,0,1,.926-.358,1.383,1.383,0,0,1,.956.358,1.2,1.2,0,0,1,.388.911,1.177,1.177,0,0,1-.388.881A1.4,1.4,0,0,1,1162.514,220.524Zm1.09,11.783h-2.21v-9.752h2.21Z",
    transform: "translate(-1092.427 -217.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M1192.6,256.677v-2.046a4.4,4.4,0,0,0,2.733.941c1.329,0,2-.388,2-1.18a.98.98,0,0,0-.164-.567,1.806,1.806,0,0,0-.463-.418,4.221,4.221,0,0,0-.687-.329c-.269-.09-.553-.209-.881-.329a9.08,9.08,0,0,1-1.075-.508,3.766,3.766,0,0,1-.807-.6,2.262,2.262,0,0,1-.478-.762,2.863,2.863,0,0,1-.164-1,2.3,2.3,0,0,1,.328-1.24,3.062,3.062,0,0,1,.9-.911,4.423,4.423,0,0,1,1.27-.553,6.073,6.073,0,0,1,1.479-.179,6.851,6.851,0,0,1,2.419.4v1.927a4.14,4.14,0,0,0-2.36-.7,2.963,2.963,0,0,0-.762.09,2.066,2.066,0,0,0-.582.239,1.114,1.114,0,0,0-.373.373.889.889,0,0,0-.135.478,1.026,1.026,0,0,0,.135.538,1.37,1.37,0,0,0,.388.388,4.109,4.109,0,0,0,.627.3c.239.09.523.194.836.3a11.6,11.6,0,0,1,1.135.523,4.093,4.093,0,0,1,.851.6,2.271,2.271,0,0,1,.538.777,2.774,2.774,0,0,1,.194,1.045,2.48,2.48,0,0,1-.344,1.3,2.8,2.8,0,0,1-.911.911,4.341,4.341,0,0,1-1.314.538,6.732,6.732,0,0,1-1.568.179A6.341,6.341,0,0,1,1192.6,256.677Z",
    transform: "translate(-1119.138 -242.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M1252.914,220.524a1.309,1.309,0,0,1-.926-.358,1.186,1.186,0,0,1-.388-.9,1.242,1.242,0,0,1,.388-.911,1.309,1.309,0,0,1,.926-.358,1.382,1.382,0,0,1,.956.358,1.2,1.2,0,0,1,.388.911,1.177,1.177,0,0,1-.388.881A1.4,1.4,0,0,1,1252.914,220.524Zm1.09,11.783h-2.21v-9.752H1254Z",
    transform: "translate(-1169.326 -217.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M1286.368,241.815a3.924,3.924,0,0,1-1.7.329c-1.9,0-2.838-.911-2.838-2.718v-5.511H1280.2v-1.732h1.628v-2.255l2.21-.627v2.882h2.33v1.732h-2.33v4.869a1.932,1.932,0,0,0,.314,1.24,1.274,1.274,0,0,0,1.045.373,1.471,1.471,0,0,0,.971-.329Z",
    transform: "translate(-1193.655 -227.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M1334.243,257.3a4.807,4.807,0,0,1-3.6-1.359,4.951,4.951,0,0,1-1.344-3.629,4.8,4.8,0,0,1,5.182-5.212,4.66,4.66,0,0,1,3.554,1.344,5.178,5.178,0,0,1,1.269,3.719,5.112,5.112,0,0,1-1.374,3.734A4.964,4.964,0,0,1,1334.243,257.3Zm.1-8.453a2.5,2.5,0,0,0-2.046.911,3.739,3.739,0,0,0-.747,2.494,3.613,3.613,0,0,0,.762,2.419,2.559,2.559,0,0,0,2.031.881,2.407,2.407,0,0,0,2-.866,4.7,4.7,0,0,0,0-4.943A2.387,2.387,0,0,0,1334.348,248.847Z",
    transform: "translate(-1235.422 -242.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M1417.06,249.67a1.848,1.848,0,0,0-1.15-.314,2,2,0,0,0-1.643.881,3.993,3.993,0,0,0-.657,2.4v4.66h-2.21v-9.752h2.21v2.031h.045a3.272,3.272,0,0,1,1-1.6,2.217,2.217,0,0,1,1.494-.582,1.853,1.853,0,0,1,.911.179Z",
    transform: "translate(-1305.261 -242.875)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkBioCloudVisitorLogo);
export default __webpack_public_path__ + "static/media/ZKBio-cloudVisitorLogo.f26ff287a39f562c827e3b70571a0de1.svg";
export { ForwardRef as ReactComponent };